import { JSX, createSignal } from 'solid-js';
import { animate } from 'motion';

interface GlowButtonProps {
  onClick?: () => void | Promise<void>;
  children?: JSX.Element;
  class?: string;
  successText?: string;
  ariaLabel?: string;
}

export default function GlowButton(props: GlowButtonProps) {
  let btnRef: HTMLButtonElement | undefined;
  const [success, setSuccess] = createSignal(false);

  const handleClick = async () => {
    if (props.onClick) await props.onClick();
    setSuccess(true);
    try {
      if (btnRef) {
        await animate(
          btnRef,
          { backgroundColor: ['rgba(124,58,237,0.16)','rgba(23,227,162,0.22)','rgba(124,58,237,0.16)'] },
          { duration: 0.45, easing: 'ease-out' }
        ).finished;
      }
    } catch {}
    setTimeout(() => setSuccess(false), 900);
  };

  return (
    <button
      ref={btnRef}
      class={`mp-glow-button ${props.class || ''}`.trim()}
      aria-label={props.ariaLabel || 'Action'}
      onClick={handleClick}
    >
      <span class="mp-glow-button-content">
        {success() ? <span class="mp-glow-button-check" aria-hidden="true">✓</span> : null}
        <span>{success() ? (props.successText || 'Saved') : props.children}</span>
      </span>
      <span class="mp-glow-sheen" aria-hidden="true" />
    </button>
  );
}
